/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {MarketplaceCatalog} from './MarketplaceCatalog';
import {PriceType} from './PriceType';
import {DamRelatedCollection} from './DamRelatedCollection';
import {TemplateFeature} from './TemplateFeature';

export interface MarketplaceChannel {
  id: number;
  header: string;
  enabled: boolean;
  marketplaceId: number;
  isSystem?: boolean;
  deleted?: boolean;
  selectedByDefault?: boolean;
  properties?: { [key: string]: string };
  categories?: MarketplaceCatalog[];
  catalogId: number;
  marketplaceCatalogId?: number;
  productCount?: number;
  templateId?: number;
  ozonPriceTypeId?: number;
  ozonPriceType?: PriceType;

  ozonPremiumPriceTypeId?: number;
  ozonPremiumPriceType?: PriceType;

  ozonMinPriceTypeId?: number;
  ozonMinPriceType?: PriceType;

  ozonOldPriceTypeId?: number;
  ozonOldPriceType?: PriceType;

  damRelatedCollectionId?: number;
  damRelatedCollection?: DamRelatedCollection;

  wildberriesPriceTypeId?: number;
  wildberriesPriceType?: PriceType;

  yamarketBasicPriceType?: PriceType;
  yamarketBasicPriceTypeId?: number;

  yamarketPurchasePriceType?: PriceType;
  yamarketPurchasePriceTypeId?: number;

  yamarketDiscountBasePriceType?: PriceType;
  yamarketDiscountBasePriceTypeId?: number;

  yamarketWithDiscountPriceType?: PriceType;
  yamarketWithDiscountPriceTypeId?: number;

  unionTemplateFeatureId?: number;
  unionTemplateFeature?: TemplateFeature;
}
